import { Form, Formik } from "formik"
import { Component, Fragment } from "react"
import { Helmet } from "react-helmet-async"
import { withRouter } from "../../helpers/withRouter"
import Select from "react-select"
import makeAnimated from "react-select/animated"
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import * as XLSX from "xlsx"
import ListPage from "../../components/custom/ListPage"
import ListPageHeader from "../../components/custom/ListPageHeader"
import { Message } from "../../helpers/language_helper"
import { ErrorMessage, SuccessMessage } from "../../helpers/notifications"
import { MutateRequest, QueryRequest } from "../../helpers/service_helper"
import { teacherPageValidation } from "../../helpers/validations"
import {
  createOneTeacherMutation,
  deleteQuizQuestionMutation,
  getAllTeachersQuery,
  getKidProfilesQuery,
  updateOneTeacherMutation,
} from "./Queries"

class Teacher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      getAllTeachersList: [],
      kidsList: [],
      removeKids: [],
      selectKids: {},
      AlreadySelect: [],
      question: [],
      schoolId: "",
      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      teacherValue: {
        id: "",
        name: "",
      },
      teacherName: "",
      columns: [
        // {
        //   name: Message("s_no"),
        //   selector: "",
        //   sortable: true,
        //   width: "10%",
        //   // cell: row => 1 + 1,
        // },
        {
          name: Message("name"),
          selector: row => row.name,
          sortable: true,
          width: "20%",
          cell: row => <span>{row.name ? row.name : ""}</span>,
        },
        {
          name: Message("name.email"),
          selector: row => row.email,
          sortable: true,
          width: "20%",
          cell: row => <span>{row.email ? row.email : ""}</span>,
        },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          width: "40%",
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {/* {Message("test")} */}
                  Weekly Report
                </Button>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {/* {Message("test")} */}
                  Monthly Report
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
      selectedOption: "",
      file: null,
      previewUrl: null,
      isValid: true,
      image_url: "",
    }
    this.handleImageChange = this.handleImageChange.bind(this)
  }
  handleImageChange(event) {
    let reader = new FileReader()
    let file = event.target.files[0]

    reader.onloadend = () => {
      this.setState({
        file: file,
        previewUrl: reader.result,
        isValid: true,
      })
    }

    reader.readAsDataURL(file)
  }
  componentDidMount() {
    this.setState({ quizId: parseInt(this.props.match.params.id, 10) }, () => {
      this.getAllTeacherList()
      this.getAllKids()
    })
  }
  getAllTeacherList = async value => {
    this.setState({
      isLoading: true,
    })

    const { listRequestModel } = this.state
    var values = listRequestModel
    this.state.schoolId = this.props.location.pathname.replace(
      "/teachers-list/",
      ""
    )
    values.schoolId = this.state.schoolId
    const response = await QueryRequest(getAllTeachersQuery, values)
    var getAllTeacherValues = response?.data?.getAllTeachers?.items
    // this.state.school = response?.data?.getAllTeachers?.items

    console.log(getAllTeacherValues)
    if (getAllTeacherValues) {
      this.setState({
        isLoading: false,
        getAllTeachersList: getAllTeacherValues,
        totalPage:
          response?.data?.getAllTeachers?.pagination?.totalCount /
          response?.data?.getAllTeachers?.pagination?.pageLimit,
        totalCount: response?.data?.getAllTeachers?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }
  getAllKids = async value => {
    this.setState({
      isLoading: true,
    })

    const { listRequestModel } = this.state
    var valuess = listRequestModel
    const response = await QueryRequest(getKidProfilesQuery, valuess)
    var kidsValues = response?.data?.getAllKidProfiles?.items

    if (kidsValues) {
      this.state.kidsList = kidsValues
      this.setState({
        isLoading: false,
        totalPage:
          response?.data?.getAllKidProfiles?.pagination?.totalCount /
          response?.data?.getAllKidProfiles?.pagination?.pageLimit,
        totalCount: response?.data?.getAllKidProfiles?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllTeacherList()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllTeacherList()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllTeacherList()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllTeacherList()
        }
      }
    )
  }

  handleEdit = row => {
    console.log("handleEdit", row)
    if (row) {
      this.state.teacherValue = {
        id: row.id,
        name: row.name,
      }
      this.state.AlreadySelect = row?.kids
      this.setState({
        quizQuestionId: row.id,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  unixconvert = values => {
    return new Date(values).toLocaleString()
  }
  /** Submit Function Start */
  handleSubmit = async values => {
    this.state.Label == "Add"
      ? this.createTeacher(values)
      : this.updateTeacher(values)
  }

  createTeacher = async values => {
    this.state.AlreadySelect = []
    if (this.state.teacherName == "") {
      ErrorMessage("Please fill Mandatory Fields")
    } else {
      let Data = {
        name: this.state.teacherName,
        schoolId: this.state.schoolId,
        kidsId: this.state.selectKids,
      }
      await MutateRequest(createOneTeacherMutation, { data: Data })
        .then(res => SuccessMessage(Message("teacher.add")))
        .catch(e => ErrorMessage(e))
      this.setState({
        buttonAction: false,
        manageModal: !this.state.manageModal,
      })
      this.getAllTeacherList()
    }
  }
  updateTeacher = async values => {
    let default_values = this.state.AlreadySelect?.map(s => {
      return s.id
    })
    let get_length = Object.keys(this.state.selectKids).length
    let Data = {
      id: this.state.teacherValue.id,
      data: {
        name: this.state.teacherName
          ? this.state.teacherName
          : this.state.teacherValue.name,
        schoolId: this.state.schoolId,
        kidsId: get_length != 0 ? this.state.selectKids.length : default_values,
      },
    }
    await MutateRequest(updateOneTeacherMutation, Data)
      .then(res => SuccessMessage(Message("teacher.update")))
      .catch(e => ErrorMessage("Please update the fields"))
    this.setState({
      manageModal: false,
    })
    this.getAllTeacherList()
  }

  addBtnClick = () => {
    this.setState({
      teacherListRow: {},
      manageModal: !this.state.manageModal,
      Label: "Add",
      AlreadySelect: [],
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      teacherListRow: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      teacherListRow: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteQuizQuestion = async id => {
    console.log("deleteQuizQuestion")
    this.setState({
      buttonAction: false,
    })
    var values = {
      id: this?.state?.teacherListRow?.id,
    }
    const response = await MutateRequest(deleteQuizQuestionMutation, values)
    const deleteOneTeacherValue = response?.data
    console.log(response)
    if (deleteOneTeacherValue.deleteOneTeacher.status === "Success") {
      SuccessMessage(Message("teacher.delete"))
      this.getAllTeacherList()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      quizQuestionDetail: url ? url : "",
    })
  }
  handleChangeName = values => {
    this.state.teacherName = values?.target?.value
      ? values?.target?.value
      : this.state.teacherValue.name
  }
  readExcel = file => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        const bufferArray = e.target.result

        const wb = XLSX.read(bufferArray, { type: "buffer" })

        const wsname = wb.SheetNames[0]

        const ws = wb.Sheets[wsname]

        const data = XLSX.utils.sheet_to_json(ws)

        resolve(data)
      }

      fileReader.onerror = error => {
        ErrorMessage(error)
      }
    })

    promise.then(d => {
      d.map(i => {
        let Data = {
          question: i.Name,
          quizId: this.state.quizId,
          quizOptions: [
            {
              option: i.Name,
            },
            {
              option: i.Name,
            },
            {
              option: i.Name,
            },
          ],
        }
        this.state.question.push(Data)
      })
    })
  }
  handleChangeKids = values => {
    this.state.selectKids = values.map(s => {
      return s.value
    })
    console.log("handleChangeKids", this.state.selectKids)
  }
  render() {
    const initialValues = this.state.teacherValue
    console.log("initialValues", initialValues)
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    let kids_list = this.state.kidsList?.map(s => {
      return {
        value: s?.id,
        label: s?.name,
      }
    })
    let already_select = this.state.AlreadySelect?.map(s => {
      return {
        value: s?.id,
        label: s?.name,
      }
    })
    const animatedComponents = makeAnimated()
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.teacher")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Teacher"}`}
                  buttonText={Message("add.teacher")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.getAllTeachersList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  rowClicked={this.HandleRowClicked}
                  pageSizeOptions={this.state.pageSizeOptions}
                  pageLimit={this.state.pageLimit}
                  onSort={this.handleSort}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
              <Row>
                <Col
                  xxs="12"
                  className="mb-4 ms-4 float-end position-relative"
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "row",
                  //   alignItems: "flex-end",
                  //   marginLeft: "760px",
                  // }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() => this.props.history.push("/schools-list")}
                  >
                    {"Back"}
                  </Button>
                </Col>
              </Row>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.teacher")}
              </ModalHeader>
              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span className=" text-lowercase">
                        <strong>{this.state.teacherValue?.question}</strong>{" "}
                        {Message("teacher")}{" "}
                      </span>
                      {"?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    disabled={this.state.buttonAction}
                    onClick={() =>
                      this.deleteQuizQuestion(this.state.teacherValue.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="lg"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.teacher")
                  : Message("update.teacher")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={teacherPageValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          {console.log(
                            "teacherListRow",
                            this.state.teacherValue
                          )}
                          <Col lg="6" xl="6" sm="12" md="12" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("name.school")}
                              </Label>
                              <Input
                                autoComplete="off"
                                className="form-control"
                                name="name"
                                type="text"
                                defaultValue={
                                  this.state.teacherValue.name
                                    ? this.state.teacherValue.name
                                    : ""
                                }
                                onChange={e => this.handleChangeName(e)}
                              />
                            </FormGroup>
                            {errors.optionC && (
                              <div className="invalid-feedback d-block">
                                {errors.number}
                              </div>
                            )}
                          </Col>
                          <Col lg="6" xl="6" sm="12" md="12" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              {/* <Checkbox  /> */}
                              <Label className="requiredField">
                                {/* {Message("name.school")} */}
                                Kids List
                              </Label>
                              {/* <Multiselect
                                placeholder="Kits List"
                                options={this.state.kidsList}
                                selectedValues={this.state.AlreadySelect}
                                displayValue="name"
                                
                                onSelect={this.onSelect}
                                onRemove={this.onRemove}
                               
                              /> */}
                              <Select
                                Component={animatedComponents}
                                options={kids_list}
                                isMulti
                                defaultValue={already_select}
                                onChange={s => this.handleChangeKids(s)}
                              />
                              {/* <Input
                                autoComplete="off"
                                className="form-control"
                                name="questionType"
                                type="select"
                                isMulti={true}
                                // defaultValue={
                                //   this.state.teacherValue.questionType
                                // }
                                // value={this.state.teacherValue.questionType}
                                onChange={e => {
                                  // this.handleOptionChange,

                                  console.log("e", e)
                                }}
                              >
                                {this.state.kidsList?.map(x => {
                                  return <option value={x.id}>{x.name}</option>
                                })}
                              </Input> */}
                            </FormGroup>
                            {errors.optionC && (
                              <div className="invalid-feedback d-block">
                                {errors.number}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Fragment>
                    </ModalBody>
                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatoryFields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button
                                  type="submit"
                                  color="primary"
                                  onClick={this.handleSubmit}
                                >
                                  {this.state.Label == "Edit"
                                    ? Message("update")
                                    : Message("add")}
                                </Button>
                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(Teacher)
